<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Settings
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
        </h3>
        <p class="card-subtitle">Apply your all global settings here.</p>
        <vs-row>
          <vs-col>
            <vs-input label="Enter radius for search user and events" type="number" v-model="data.radius" />
          </vs-col>
          <vs-col>
            <vs-input label="Enter api_key of firebase" type="text" v-model="data.api_key" />
          </vs-col>
          <vs-col>
            <vs-input label="Enter view count for popular events" type="number" v-model="data.viewCount" />
          </vs-col>
          <vs-col class="mb-4">
            <vs-select label="Choose Translation API" v-model="data.translateAPI">
              <vs-select-item value="Select service" text="Select service" disabled>Select service</vs-select-item>
              <vs-select-item v-for="item in ['google1', 'google2', 'gpt', 'kriesler g-translate']" :key="item"
                :value="item" :text="item"></vs-select-item>
            </vs-select>
          </vs-col>
          <vs-col class="mb-1">
            In case google1 does not work, try google2, if both do not work, try kreiser g-translate.
          </vs-col>
          <vs-col class="mb-3">
            {{ data.translateAPI === 'vialets g-translate' ? `Vialet's translate library does not support Odia language`
              : '' }}
          </vs-col>
          <vs-col>
            <vs-button icon="save" @click="save">Save</vs-button>
          </vs-col>
          <vs-col class="mt-3">
            <a href="https://www.notion.so/Notification-Tutorial-Kundali-PDF-key-6a124d5289844584a8778423c0bc2d86"
              target="_blank">
              Notification Tutorial & Kundli Keys
            </a>
          </vs-col>
          <vs-col class="mt-2">
            <a href="https://www.notion.so/UserProperty-03f3718085da48bc9cbdcca8872ff4d2" target="_blank">
              User Properties
            </a>
          </vs-col>
          <vs-col class="mt-2">
            <a href="https://www.notion.so/FirebaseRemoteConfig-c13a7e37772749ef8a50166d5cf98640?pm=c" target="_blank">
              Firebase Remote Config
            </a>
          </vs-col>
        </vs-row>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "../../../common/constants";
export default {
  name: "settings",
  data: () => ({
    data: {
      radius: "",
      api_key: "",
      viewCount: "",
      translateAPI: "Select service",
    },
  }),
  computed: {},
  methods: {
    save() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .post(API.SETTINGS, this.$data.data, { headers })
        .then((r) => {
          console.log(r.status);
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$ls.set("api_settings", JSON.stringify(this.$data.data));

            this.$vs.notify({
              text: "Settings Updated Successfully!",
              color: "success",
              position: "right",
            });
            getSettings();
          } else {
            this.$vs.notify({
              title: "Settings Error",
              text: r.data.error,
              color: "danger",
              position: "right",
            });
          }
        })
        .catch(() => { });
    },
    getSettings() {
      this.$vs.loading();
      api
        .get(API.SETTINGS, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.data = r.data;
          this.$ls.set("api_settings", JSON.stringify(r.data));
        })
        .catch(() => { });
    }
  },
  created() {
    this.getSettings();
  },
};
</script>
<style scoped></style>
